/* @flow */

import React from 'react';
import { Segment, Divider, Grid } from 'semantic-ui-react';
import NavigationLinkForm from './NavigationLinkForm';
import NavigationLinkButtons from './NavigationLinkButtons';
import OctoResourceCard from 'shared/components/OctoResourceCard';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  link: NavigationContentLink,
  linkCount: number,
  defaultResourceStrategy: ResourceStrategy,
  onUpdate: (link: NavigationContentLink) => void,
  onReorder: (link: NavigationContentLink, order: number) => void,
  onDelete: (link: NavigationContentLink) => void,
};

const NavigationLinkItem = ({
  link,
  linkCount,
  defaultResourceStrategy,
  onUpdate,
  onReorder,
  onDelete,
}: Props) => {
  const titleChanged = (title: string) =>
    onUpdate({
      ...link,
      title,
    });

  const resourceUpdated = (resource: CatalogResource) =>
    onUpdate({
      ...link,
      image: resource,
    });

  const resourceDeleted = () =>
    onUpdate({
      ...link,
      image: undefined,
    });

  return (
    <Segment attached>
      <Grid>
        <Grid.Column width={6} verticalAlign="middle">
          <NavigationLinkForm link={link} onTitleChange={titleChanged} />
          <Divider />
          <NavigationLinkButtons
            link={link}
            linkCount={linkCount}
            onOrderChange={onReorder}
            onDelete={onDelete}
          />
        </Grid.Column>
        <Grid.Column width={2} />
        <Grid.Column width={8}>
          <OctoResourceCard
            strategy={defaultResourceStrategy}
            resource={link.image}
            onUpdated={resourceUpdated}
            onDeleted={resourceDeleted}
          />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default NavigationLinkItem;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinkItem.js